import React from 'react';

import { useAiWidgetConfig } from '../../controllers/ai-widget-config-context';
import { AiCornerAgent } from '../ai-corner-agent';
import { AiSearchTrigger, AiSearchTriggerFloating } from '../ai-search-trigger';

/**
 * AiSearchTrigger with props from the AiWidgetConfigProvider
 */
export const AiSearchTriggerWithContext = (): React.JSX.Element => {
	const { supportWidgetConfig } = useAiWidgetConfig();

	return (
		<AiSearchTrigger
			site={supportWidgetConfig.site}
			siteId={supportWidgetConfig.siteId}
			widgetId={supportWidgetConfig.widgetId}
			widgetTheme={supportWidgetConfig.widgetTheme}
		/>
	);
};

/**
 * AiSearchTriggerFloating with props from the AiWidgetConfigProvider
 */
export const AiSearchTriggerFloatingWithContext = (): React.JSX.Element => {
	const { supportWidgetConfig } = useAiWidgetConfig();

	return (
		<AiSearchTriggerFloating
			site={supportWidgetConfig.site}
			siteId={supportWidgetConfig.siteId}
			widgetId={supportWidgetConfig.widgetId}
			widgetTheme={supportWidgetConfig.widgetTheme}
		/>
	);
};

/**
 * AiCornerAgent with props from the AiWidgetConfigProvider
 */
export const AiCornerAgentWithContext = (): React.JSX.Element => {
	const { supportWidgetConfig } = useAiWidgetConfig();

	return (
		<AiCornerAgent
			site={supportWidgetConfig.site}
			siteId={supportWidgetConfig.siteId}
			widgetId={supportWidgetConfig.widgetId}
		/>
	);
};
